module.exports = __webpack_public_path__ + "static/media/searchIcon.23e8e59e.svg";